import type { FragmentTranslator } from "@totalenergiescode/mobility-business-rev-form-data/components";
import { useFormDataContext } from "@totalenergiescode/mobility-business-rev-form-data/components";
import { useSyncExternalStore } from "react";

export const useTranslationFailures = (id: string) => {
  const { translator } = useFormDataContext();
  const x = translator as FragmentTranslator;

  const allFailures = useSyncExternalStore(x.store.subscribe, x.store.snapshot);

  return Array.from(allFailures.get(id) || []);
};
